module.exports = __webpack_public_path__ + "img/9.6a3a243c.jpeg";